// components/RenvoyerConfirmation.jsx
// Demande d'un nouveau lien de confirmation d'adresse. Réponse toujours identique, adresse connue ou non.
// Avec `email` fourni (cas de la connexion), un simple bouton ; sans, un champ e-mail.

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { envoyerAuth, langueInterface, messageErreurOubli } from '../utils/authOubli';

export default function RenvoyerConfirmation({ email: emailConnu = '' }) {
  const { t, i18n } = useTranslation();
  const [saisie, setSaisie] = useState('');
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState('');
  const [enCours, setEnCours] = useState(false);
  const email = emailConnu || saisie;

  const envoyer = async (e) => {
    e.preventDefault();
    setErreur('');
    setEnCours(true);
    const rep = await envoyerAuth('/api/auth/renvoyer-confirmation', { email, langue: langueInterface(i18n) });
    setEnCours(false);
    if (rep.ok) setEnvoye(true); else setErreur(messageErreurOubli(t, rep.code));
  };

  if (envoye) return <div className="auth-success">{t('auth.confirmationRenvoyee')}</div>;

  return (
    <form onSubmit={envoyer} className="auth-form">
      {erreur && <div className="auth-error">{erreur}</div>}
      {!emailConnu && (
        <div className="form-group">
          <label htmlFor="emailRenvoi">{t('auth.email')}</label>
          <input id="emailRenvoi" type="email" value={saisie} onChange={(e) => setSaisie(e.target.value)} placeholder={t('auth.emailPlaceholder')} required autoComplete="email" />
        </div>
      )}
      <button type="submit" className="auth-submit" disabled={enCours || !email}>{t('auth.renvoyerLien')}</button>
    </form>
  );
}
